import { Loading, Icon, Breakpoints } from 'JBSrc/constants';
import { sessionFlash } from 'JBSrc/session-flash';
import { scrollTo } from 'JBPlugin/scroll-to';
import { fieldLogic } from 'JBSrc/field-logic';
let moment = require('moment');

class EventForm {
	constructor(){
		this.eventFormClass = '.event-form';
		this.eventFormContainer = '.event-form-container';
		this.eventEventFlagComment = '#addEventFlagComment';
		this.eventSummaryClass = '.event-summary';
		this.eventSummaryElement = '[data-event-summary]';
		this.current_summary_tab = 'summary';
		this.current_section = '';
		this.unsaved_progress = false;
		this.current_navigation_sections = [];
		this.fields = [];
		this.eventNavigationClass = '.event-section-nav';
		this.eventActionElement = '[data-event-action]';
		this.submitButton = '.submitEventForm';
		this.mode = $('input[name="mode"]').val();
		this.id = $('input[name="id"]').val();
		this.eventType = $('input[name="type"]').val();
		this.flags = [];
		this.currentFlagRequest = null;

		try {
			if(localStorage.getItem('current_event') == this.id){
				this.current_section = localStorage.getItem('current_section');
			}
		} catch(e) {}
	}

	getFieldStatuses(){
		let self = this;
		const queryString = $.param({ eventType: self.eventType, id: self.id });
		$.get('/ajax/events/fields-tree?' + queryString, function(data){
			if(data.fields !== undefined){
				self.fields = data.fields;
			}
			if($(self.eventNavigationClass).length && data.sections !== undefined){
				$(self.eventNavigationClass + ' li').removeClass('valid invalid has-flags');
				$(self.eventNavigationClass + ' .flag').remove();
				for (let section in data.sections) {
					if (data.sections.hasOwnProperty(section)) {
						let config = data.sections[section];
						$(self.eventNavigationClass + ' [data-section="' + section + '"]').parent('li').addClass(config['classes']);
						if(config['flags']){
							$(self.eventNavigationClass + ' [data-section="' + section + '"]').append(' <span class="flag">' + Icon.flag + '<span class="sr-only">Mark field as required</span></span>');
						}
						if(!config['valid']){
							$(self.eventNavigationClass + ' [data-section="' + section + '"]').append(' <span class="flag">' + Icon.invalid + '<span class="sr-only">Fields in this section are required</span></span>');
						}
					}
				}
			}
		});
	}

	buildNavigation(){
		let self = this;
		if($(self.eventNavigationClass).length){
			$(self.eventNavigationClass).html(Loading.event_nav);
			$.get('/ajax/events/section/navigation?eventType=' + self.eventType, function(data){
				let html = [];
				html.push('<button class="btn btn-primary btn-block" type="button" data-toggle="collapse" data-target="#event-section-collapse" aria-expanded="false" aria-controls="event-section-collapse">Show/Hide Sections</button>');
				html.push('<div id="event-section-collapse" class="nav-collapse collapse"><ol>');
				for (let key in data) {
					if (data.hasOwnProperty(key)) {
						if(self.current_section === '' && !data[key].hasOwnProperty('children')){
							self.current_section = key;
						}

						if(data[key].hasOwnProperty('children')){
							html.push('<li><a data-parent="' + key + '">' + data[key]['title'] + '</a>');
							html.push('<ul data-parent="' + key + '">');
							for (let child_key in data[key]['children']) {
								if(self.current_section === ''){
									self.current_section = child_key;
								}
								let child = data[key]['children'][child_key];
								html.push('<li><a data-section="' + child_key + '">' + child + '</a></li>');
								self.current_navigation_sections.push(child_key);
							}
							html.push('</ul>');
						}else{
							html.push('<li><a data-section="' + key + '">' + data[key]['title'] + '</a>');
							self.current_navigation_sections.push(key);
						}

						html.push('</li>');
					}
				}
				html.push('</ol></div>');
				$(self.eventNavigationClass).html(html.join("\n"));

				self.buildForm();
			},'json');

			$(document).on('click', self.eventNavigationClass + ' a', function(e){
				e.preventDefault();

				let parent = $(this).data('parent');
				let section = $(this).data('parent') ? $('[data-parent="' + parent + '"]').find('a:first').data('section') : $(this).data('section');
				if($(window).width() <= Breakpoints.sm){
					$('#event-section-collapse').collapse('hide');
				}
				self.progressCheck(section);
			});
		}
	}

	buildForm(section){
		let self = this;
		if(section === undefined){
			section = self.current_section;
		}
		if($(self.eventFormContainer).length){
			$(self.eventFormContainer).addClass('freeze-loading').prepend(Loading.event_section);
			scrollTo('#event-form-top');
			$.get('/ajax/events/form?section=' + section + '&id=' + self.id, function(data){
				self.current_section = section;

				try {
					localStorage.setItem('current_event', self.id);
					localStorage.setItem('current_section', self.current_section);
				} catch(e) {}

				$(self.eventFormContainer).html(data).removeClass('freeze-loading');
				$(self.eventNavigationClass + ' li').removeClass('active');
				$(self.eventNavigationClass + ' a[data-section="' + section + '"]').parent('li').addClass('active');

				if(self.fieldsLocked()){
					$('[data-section="' + section + '"] :input').attr('disabled', true);
					$('[data-section="' + section + '"] :input').addClass('disabled');
					$('[data-section="' + section + '"] .btn').attr('disabled', true);
					$('[data-section="' + section + '"] .btn').addClass('disabled');
				}
				let x = window.scrollX, y = window.scrollY;
				if($('[data-section="' + section + '"] :input:visible:first').length){
					$('[data-section="' + section + '"] :input:visible:first').focus();
				}
				window.scrollTo(x, y);
			}).then(function(){
				self.showHideChecks();
				self.initFlagsAndPlugins();
				self.getFieldStatuses();
				self.nextPreviousCheck();
				self.handleEventComments();
			});
		}
	}

	handleEventComments() {
		let self = this;
		if($(self.eventSummaryClass).length){
			self.current_summary_tab = $(self.eventSummaryClass + '.active').attr('id');

			$.get('/ajax/events/' + self.id + '/comments', function (response) {
				if (response.total > 0){
					$('#previous-comments-button').html('<p><button href="#previous-comments" data-event-summary="previous-comments" type="button" class="btn btn-sm btn-secondary">View previous comments</button></p>');

					let html = [];
					html.push('<p><button href="#summary" data-event-summary="summary" class="btn btn-sm btn-secondary" type="button">Back</button></p>');
					html.push('<div id="previous-comments__list" class="accordion">');
					for (let key in response.data) {
						if (response.data.hasOwnProperty(key)) {
							let comment = response.data[key];

							html.push(`<div class="accordion__item">`);
							html.push(`		<h3 class="accordion__item-title">`);
							html.push(`			<button class="btn btn-link" type="button" data-toggle="collapse" data-parent="#previous-comments__list" data-target="#previous_comments_accordion-collapse-${comment['uuid']}" aria-expanded="false" aria-controls="previous_comments_accordion-collapse-${comment['uuid']}">`);
							html.push(`				<div id="previous_comments_accordion-heading-${comment['uuid']}" class="d-flex w-100 align-items-center">`);
							html.push(`		  			<span class="card__collectionLog--status badge badge-log badge-${comment['status_slug']} mr-2">${ comment['status']}</span>`);
							html.push(`		  			<div class="card__collectionLog--actioned_by mr-2">Reviewed By: ${ comment['reviewed_by']}</div> `);
							html.push(`		  			<div class="card__collectionLog--date ml-auto pr-4">` + moment(comment['reviewed_date']).format('D MMM YYYY h:mma') + `</div>`);
							html.push(`				</div>`);
							html.push(`				<span class="accordion__indicators">`);
							html.push(`					<span class="accordion__indicator accordion__indicator--open">${Icon.plus}</span>`);
							html.push(`					<span class="accordion__indicator accordion__indicator--close">${Icon.minus}</span>`);
							html.push(`				</span>`);
							html.push(`			</button>`);
							html.push(`		</h3>`);

							html.push(`		<div id="previous_comments_accordion-collapse-${comment['uuid']}" class="collapse" aria-labelledby="previous_comments_accordion-heading-${comment['uuid']}" data-parent="#previous-comments__list">`);
							html.push(`			<div class="accordion__item-content">`);
							html.push(`				<div class="py-2">`);

							if(comment['flags'] !== null){
								html.push(`<p class="h5 mt-0">The fields required for review:</p>`);
								for(let field in comment['flags']){
									if (comment['flags'].hasOwnProperty(field)) {
										let flag = comment['flags'][field];

										html.push(`<p class="mb-3">`);
										html.push(`	<strong>${flag['label']}</strong><br />`);
										html.push(`	${flag['comment'] ? flag['comment'] : 'Please review'}`);
										html.push(`</p>`);
									}
								}
							}

							if (comment['reviewed_comments'] !== null) {
								html.push(`<p class="h5 mt-2">Further comments:</p>`);
								html.push(`	<p>${comment['reviewed_comments']}</p>`);
							}

							if (comment['attachments'] !== null) {
								html.push(`<div class="card card__collectionLog__field mb-3">`);
								html.push(`		<div class="card-header">Attachments</div>`);
								html.push(`		<div class="card-body"><ul class="pt-2">`);

								for (let key in comment['attachments']) {
									if (comment['attachments'].hasOwnProperty(key)) {
										let attachment = comment['attachments'][key];

										html.push(`<li><a href="${attachment['url']}" target="_blank">${attachment['name']}</a></li>`);
									}
								}
								html.push(`		<ul></div>`);
								html.push(`</div>`);
							}

							html.push(`				</div>`);
							html.push(`			</div>`);
							html.push(`		</div>`);
							html.push(`</div>`);
						}
					}
					html.push('</div>');
					$('#previous-comments').html(html.join("\n"));

					$('.collapse').on('shown.bs.collapse', function () {
						$(this).prev().addClass('open');
					});

					$('.collapse').on('hidden.bs.collapse', function () {
						$(this).prev().removeClass('open');
					});
				}
			}, 'json');

			$(document).on('click', self.eventSummaryElement, function(e){
				e.preventDefault();
				$(self.eventSummaryClass).removeClass('active');
				$(self.eventSummaryClass + '#' + $(this).data('event-summary')).addClass('active');
			});
		}
	}

	getFormData(){
		let self = this;
		let unindexed_array = $(self.eventFormClass).serializeArray();
		let indexed_array = {};

		$.map(unindexed_array, function(n, i){
			//boolean
			if(n['value'].toLowerCase() === 'true' || n['value'].toLowerCase() === 'false'){
				indexed_array[n['name']] = JSON.parse(n['value']);
			//empty string
			}else if(n['value'] === ""){
				indexed_array[n['name']] = null;
			}else{
				indexed_array[n['name']] = n['value'];
			}
		});

		return indexed_array;
	}

	getFormStatus(){
		let self = this;
		if(self.mode === 'create'){
			$.getJSON('/events/starting', function(data){
				if(data.id !== undefined){
					self.id = data.id;
					$('input[name="id"]').val(data.id);
				}
			}).then(function(){
				self.buildNavigation();
			});
		}else{
			self.buildNavigation();
		}
	}

	showHideChecks(){
		let self = this;
		const data = self.getFormData();
		let isVisible, passes, field;

		$('.form-group[data-field]').each(function(){
			isVisible = true;
			field = $(this).data('field');
			if($(this).data('show_when') !== undefined && $(this).data('show_when') !== ''){
				passes = self.checkFieldPasses($(this).data('show_when'));
				isVisible = passes;
			}else if($(this).data('hide_when') !== undefined &&  $(this).data('hide_when') !== ''){
				passes = self.checkFieldPasses($(this).data('hide_when'));
				isVisible = !passes;
			}

			if(isVisible){
				$(this).show();
			}else{
				$(this).hide();
			}
		});
	}

	nextPreviousCheck(){
		let self = this, index;

		//Next/previous button checks
		$('[data-event-action="previous_section"]').show();
		$('[data-event-action="next_section"]').show();
		index = self.current_navigation_sections.indexOf(self.current_section);
		if(index === 0){
			$('[data-event-action="previous_section"]').hide();
		}else if(index === (self.current_navigation_sections.length - 1)){
			$('[data-event-action="next_section"]').hide();
		}
	}

	checkFieldPasses(rule){
		let self = this;
		const data = self.getFormData();
		let passes = [];
		let ors = Object.keys(rule).filter((key) => {
			return key.startsWith('or_');
		});

		for (let field in rule) {
			if (ors.includes(field)) {
				let trimmed = field.substr(3);

				if (data[trimmed] === rule[field]) {
					return true;
				}
			}

			if (! ors.includes(field) && Array.isArray(rule[field])) {
				passes.push(rule[field].includes(data[field]));
			} else {
				if (rule[field] === 'not null') {
					passes.push(data[field] !== null);
				} else {
					passes.push(data[field] === rule[field]);
				}
			}
		}
		return !passes.includes(false);
	}

	initFlagsAndPlugins(){
		let self = this;

		if(self.mode !== 'create'){
			// Don't request flags if there's already flags being saved
			if (self.currentFlagRequest === null) {
				$.getJSON('/events/' + self.id + '/flags', function(data){
					if(data.flags !== undefined){
						self.flags = data.flags;
						self.updateEventFlagText();
					}
				}).then(function(){
					self.initFlags();
					self.initFormPlugins();
				});
			}else{
				self.initFlags();
				self.initFormPlugins();
			}
		}else{
			self.initFormPlugins();
		}
	}

	initFlags(){
		let self = this;
		let field, label, labelText;
		let comment_btn = '', activeClass = '';
		const adminMode = $(self.eventFormClass).data('manager-actions');

		// Update fields in the form
		$(self.eventFormClass + ' .form-group[data-field]').each(function(){
			field = $(this).data('field');
			label = $(this).find('label[for="' + field + '"]');
			if(label.length){
				labelText = label.html();

				if(label.find('.event-flag').length === 0){
					if(adminMode){
						comment_btn = '<a href="#addEventFlagComment" data-toggle="modal" data-field="' + field + '" data-label="' + label.text() + '" title="Add Comments"><span class="sr-only">Add Comments</span><span class="comment">' + Icon.comment + '</span></a>';
						label.html('<span class="event-flag" data-toggle="flag_field" data-field="' + field + '" title="Mark/unmark this field as required"><a class="flag">' + Icon.flag + '<span class="sr-only">Mark field as required</span></a>' + comment_btn + '</span> ' + labelText);
					}else if(self.flags.hasOwnProperty(field)){
						comment_btn = '';
						if(self.flags[field]['comment'] !== null && self.flags[field]['comment'] !== ''){
							comment_btn = '<a data-toggle="popover" data-field="' + field + '" data-label="' + label.text() + '" data-content="' + self.flags[field]['comment'] + '" title="Comments"><span class="sr-only">View Comments</span><span class="comment">' + Icon.comment + '</span></a>';
						}
						label.html('<span class="event-flag" data-toggle="flag_field" data-field="' + field + '" title="This field needs review"><a class="flag flagged">' + Icon.flag + '<span class="sr-only">This field needs review</span></a>' + comment_btn + '</span> ' + labelText);
					}
				}

				//check if flag has been set for this field
				if(self.flags.hasOwnProperty(field)){
					activeClass = self.flags[field]['active'] ? 'active' : 'reviewed';
					$('.event-flag[data-field="' + field + '"]').addClass('flagged ' + activeClass);
					if($('#' + field).length){
						$('#' + field).addClass('flagged');
					}

					//check if comment has been added
					if(self.flags[field]['comment'] !== null && self.flags[field]['comment'] !== ''){
						$('.event-flag[data-field="' + field + '"] .comment').addClass('hasComment');
					}
				}
			}
		});
	}

	initFormPlugins(){
		fieldLogic();
	}

	adminTriggers(){
		let self = this, flag, field;
		if($(self.eventFormClass).data('manager-actions')){
			$(document).on('click', '[data-toggle="flag_field"] .flag', function(e){
				e.preventDefault();
				flag = $(this).parents('.event-flag');
				field = flag.data('field');
				flag.toggleClass('flagged');
				if($('#' + field).length){
					$('#' + field).toggleClass('flagged');
				}

				//check if flag has been set for this field
				if(flag.hasClass('flagged')){
					self.flags[field] = {
						'field': field
					};
				} else {
					flag.removeClass('active reviewed');
					flag.find('.comment').removeClass('hasComment');
					if(self.flags.hasOwnProperty(field)){
						delete self.flags[field];
					}
				}

				self.saveFlags();
				self.unsaved_progress = true;
				self.updateEventFlagText();
			});

			$('[data-form="save_comment"]').submit(function(e){
				e.preventDefault();
				let form = $(this);
				let comment = form.find('[data-field="comment"]').val();
				let field = form.data('field');

				if(!self.flags.hasOwnProperty(field)){
					self.flags[field] = {'field' : field};
				}
				
				self.flags[field]['comment'] = comment;
				$('.event-flag[data-field="' + field + '"] .comment').addClass('hasComment');
				$(self.eventEventFlagComment).modal('hide');
				self.saveFlags();

				return false;
			});

			$(document).on('click', '[data-action="remove_comment"]', function(e){
				e.preventDefault();
				field = $(this).parents('form').data('field');
				if(self.flags.hasOwnProperty(field) && self.flags[field]['comment']){
					self.flags[field]['comment'] = null;
				}
				$('.event-flag[data-field="' + field + '"] .comment').removeClass('hasComment');
				self.saveFlags();
				$(self.eventEventFlagComment).modal('hide');
			});

			$(document).on('click', '[data-action="remove_all_flags"]', function(e){
				e.preventDefault();
				if(confirm('Are you sure you\'d like to remove all the current flags and their comments? This can\'t be undone.')){
					self.flags = [];
					self.saveFlags();

					// Remove flags/comments in the current section
					$(self.eventFormClass).find('.event-flag').each(function(){
						$(this).removeClass('active reviewed flagged');
						$(this).find('.comment').removeClass('hasComment');
					});					
				}
			});

			$(self.eventEventFlagComment).on('show.bs.modal', function (event) {
				let button = $(event.relatedTarget);
				let field = button.data('field');
				let label = button.data('label');
				let modal = $(this);

				modal.find('[data-event-label]').text(label);
				modal.find('[data-form="save_comment"]').data('field', field);
				modal.find('[data-field="comment"]').val(self.flags.hasOwnProperty(field) && self.flags[field].hasOwnProperty('comment') ? self.flags[field]['comment'] : '');
			});
		}
	}

	fieldsLocked(){
		let self = this;
		return (parseInt($(self.eventFormClass).data('editable')) === 0 || parseInt($(self.eventFormClass).data('locked')) === 1) && !$(self.eventFormClass).data('manager-actions');
	}

	updateEventFlagText(){
		let self = this, flag_count = 0, message = '';

		if(self.flags){
			flag_count = _.size(self.flags);
			if(flag_count > 0){
				message = '<strong>' + flag_count + ' flag' + (flag_count != 1 ? 's':'') + ' marked</strong> <p><a href="#removeAllFlags" data-action="remove_all_flags" title="Remove all current flags" class="btn btn-danger btn-sm">Remove All Flags</a></p>';
				$('#status').val('Please Review');
			}
		}

		$('[data-flags-list]').html(message);
	}

	initTriggers(){
		let self = this, section, index, action, buttonText, field;

		$(window).on('beforeunload', function() {
			if ($(self.eventFormClass).hasClass('dirty') || self.unsaved_progress) {
				return "You have unsaved changes. If you leave before saving, your changes will be lost.";
			}
		});

		self.adminTriggers();
		self.getFormStatus();
		$(document).on('change', self.eventFormContainer + ' :input', function(e){
			e.preventDefault();
			self.unsaved_progress = true;
			self.showHideChecks();
		});
		$(document).on('click', self.eventActionElement, function(e){
			e.preventDefault();
			action = $(this).data('event-action');

			switch(action){
				case 'next_section':
					index = self.current_navigation_sections.indexOf(self.current_section);
					if(index >= 0 && index < self.current_navigation_sections.length - 1){
						section = self.current_navigation_sections[index + 1];
				   	}

					if(!self.fieldsLocked()){
						self.unsaved_progress = true;
					}
					self.progressCheck(section);
				break;

				case 'previous_section':
					index = self.current_navigation_sections.indexOf(self.current_section);
					if((index-1) >= 0){
						section = self.current_navigation_sections[index - 1];
					}
					self.progressCheck(section);
				break;

				case 'save_progress':
					buttonText = $(this).text();
					$(this).html(Loading.icon + buttonText);
					self.saveProgress(self.current_section);
				break;

				case 'save_progress_exit':
					buttonText = $(this).text();
					if(!self.fieldsLocked()){
						$(this).html(Loading.icon + buttonText);
						self.saveProgress(self.current_section, true);
					}else{
						window.location.href = '/profile/my-events';
					}
				break;

				case 'save_the_date':
					buttonText = $(this).text();
					$(this).html(Loading.icon + buttonText);
					self.saveTheDate();
				break;
			}
		});

		$(self.eventFormClass).on('submit', function(e){
			e.preventDefault();
			let form = $(this);
			let formData = new FormData(this);
			let continueSubmit = true;
			const adminMode = $(self.eventFormClass).data('manager-actions');

			if(adminMode && $('#status').val() == ''){
				continueSubmit = confirm('Are you sure you\'d like to save this event without updating the status?');
			}

			if(continueSubmit){
				$(self.eventFormClass + ' button[type="submit"]').each(function(){
					buttonText = $(this).text();
					$(this).html(Loading.icon + buttonText);
				});

				if($(self.eventFormClass).data('manager-actions')){
					self.saveFlags(true, form, formData);
				}else{
					self.save(form, formData);
				}
			}else{
				return false;
			}
		});

		if(self.fieldsLocked()){
			$(self.eventFormClass + ' button[type="submit"]').remove();
			$(self.eventFormClass + ' [data-event-action="save_progress"]').remove();
			$(self.eventFormClass + ' [data-event-action="save_progress_exit"]').text('Exit');
			if(parseInt($(self.eventFormClass).data('locked')) === 1){
				$(self.eventFormContainer).before('<div class="alert alert-warning">' + Icon.lock + ' This EMP is locked from making further changes</div>');
			}else{
				$(self.eventFormContainer).before('<div class="alert alert-warning">' + Icon.lock + ' This EMP is in read-only mode. No changes will be made</div>');
			}
		}
	}

	progressCheck(section){
		if(this.unsaved_progress){
			this.saveProgress(section);
		}else{
			this.buildForm(section);
		}
	}

	save(form, formData){
		let self = this;
		let section = self.current_section;

		$.ajax({
			url: form.attr('action'),
			type: 'POST',
			data: formData,
			success: function (data) {
				$(self.eventFormClass + ' button[type="submit"] .loading-icon').remove();

				if(!data.ok){
					if(data.error_field !== '' && self.fields.hasOwnProperty(data.error_field)){
						section = self.fields[data.error_field]['section'];
					}
					self.buildForm(section);
				}else{
					self.unsaved_progress = false;
					$(self.eventFormClass).removeClass('dirty');

					if(data.redirect !== undefined){
						sessionFlash(data.message, true, 3000, data.redirect);
					}else{
						sessionFlash(data.message, true);
					}
				}
			},
			error: function(){
				$(self.eventFormClass + ' button[type="submit"] .loading-icon').remove();
				self.unsaved_progress = true;
			},
			cache: false,
			contentType: false,
			processData: false
		});
	}

	saveProgress(goToSection, exit){
		let self = this;

		if(tinymce !== undefined){
			for (var i = 0; i < tinymce.editors.length; i++) {
				tinymce.editors[i].save();
			}
		}

		let form = $(self.eventFormClass);
		let formData = new FormData(form[0]);
		if(goToSection === undefined){
			goToSection = self.current_section;
		}
		if(exit === undefined){
			exit = false;
		}

		//Don't save progress if not admin and is approved
		if(self.fieldsLocked()){
			return;
		}

		$.ajax({
			url: '/events/save/progress',
			type: 'POST',
			data: formData,
			success: function (data) {
				$(self.eventActionElement + ' .loading-icon').remove();
				if(!data.ok){
					self.buildForm(self.current_section);
				}else{
					if(exit){
						sessionFlash(data.message, true, 3000, '/profile');
					}

					self.unsaved_progress = false;
					self.buildForm(goToSection);
				}
			},
			error: function(){
				$(self.eventActionElement + ' .loading-icon').remove();
				self.unsaved_progress = false;
			},
			cache: false,
			contentType: false,
			processData: false
		}).then(function(){
			if($(self.eventFormClass).data('manager-actions')){
				self.saveFlags();
			}
		});
	}

	saveTheDate(){
		let self = this;
		let form = $(self.eventFormClass);
		let formData = new FormData(form[0]);
		let section = self.current_section;

		$.ajax({
			url: '/events/save/the-date',
			type: 'POST',
			data: formData,
			success: function (data) {
				$(self.eventActionElement + ' .loading-icon').remove();

				if(!data.ok){
					if(data.error_field !== '' && self.fields.hasOwnProperty(data.error_field)){
						section = self.fields[data.error_field]['section'];
					}
					self.buildForm(section);
				}else{
					self.unsaved_progress = false;
					$(self.eventFormClass).removeClass('dirty');

					if(data.redirect !== undefined){
						sessionFlash(data.message, true, 3000, data.redirect);
					}else{
						sessionFlash(data.message, true);
					}
				}
			},
			error: function(){
				$(self.eventActionElement + ' .loading-icon').remove();
				self.unsaved_progress = true;
			},
			cache: false,
			contentType: false,
			processData: false
		});
	}

	saveFlags(alsoSaveForm, form, formData) {
		let self = this;

		// If there's an ongoing request, abort it
		if (self.currentFlagRequest !== null) {
			self.currentFlagRequest.abort();
		}

		self.currentFlagRequest = $.ajax({
			url: '/events/save/flags',
			type: 'POST',
			data: {
				_token: window.csrf_token,
				id: self.id,
				flags: JSON.stringify(Object.values(self.flags))
			},
			success: function (data) {
				if (data.flags) {
					self.flags = data.flags;
				}
				self.updateEventFlagText();

				// Specifically on save
				if(alsoSaveForm === true){
					self.save(form, formData);
				}
			},
			complete: function() {
				// Clear the current request once completed
				self.currentFlagRequest = null;
			}
		});
	}
}
(function($) {
	const eventForm = new EventForm;
	if($(eventForm.eventFormClass).length){
		eventForm.initTriggers();
	}
})(jQuery);
